import { EnumItem } from "./enum-item";

export class SettingsPropertyModel {
    BindingPath:string;
    Type:string;
    IsCollection:boolean;
    IsEnum:boolean;
    IsTypeByAttribute:boolean;
    Enums:EnumItem[];
    GenericArgumentType:string;
    CollectionComplexProperties:SettingsPropertyModel[];



    constructor(bindingPath:string, type:string, isCollection:boolean, isEnum:boolean, isTypeByAttribute:boolean, genericArgumentType:string, colComplexProps:SettingsPropertyModel[], enums:EnumItem[]){
        this.BindingPath = bindingPath;
        this.Type = type;
        this.IsCollection = isCollection;
        this.GenericArgumentType = genericArgumentType;
        this.CollectionComplexProperties = colComplexProps;1
        this.IsEnum = isEnum;
        this.Enums = enums;
        this.IsTypeByAttribute  = isTypeByAttribute;
    }

    static map(property: any): SettingsPropertyModel {

        var properties:SettingsPropertyModel[] = [];
        property.CollectionComplexProperties.forEach(c => {
            let sp = SettingsPropertyModel.map(c);
            properties.push(sp);
        });

        var enums:EnumItem[] = [];

        if(property.Enums!=null){
            property.Enums.forEach(i=> {
                let it = EnumItem.map(i);
                enums.push(it);
            });
        }

        return new SettingsPropertyModel(property.BindingPath, property.Type, property.IsCollection, property.IsEnum, property.IsTypeByAttribute, property.GenericArgumentType, properties, enums);
    }
}
